// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Type definitions
import { ForgeProjectContext } from "./SDKForgeProjectContext";
import { ForgeProjectDocumentPreview } from "./SDKForgeProjectDocumentPreview";
import { ForgeProjectFeaturePreview } from "./SDKForgeProjectFeaturePreview";
export class ForgeProject {
    constructor(model) {
        var _a, _b, _c, _d, _e, _f;
        this.id = model.id;
        this.liveblocksRoomId = model.liveblocksRoomId;
        this.workspaceId = model.workspaceId;
        this.projectContextId = model.projectContextId;
        this.name = model.name;
        this.description = model.description;
        this.instruction = model.instruction;
        this.tags = model.tags;
        this.accessMode = model.accessMode;
        this.defaultRole = model.defaultRole;
        this.effectiveRole = model.effectiveRole;
        this.isArchived = (_a = model.isArchived) !== null && _a !== void 0 ? _a : false;
        this.emoji = model.emoji;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = new Date(model.updatedAt);
        this.numberOfFeatures = model.numberOfFeatures;
        this.numberOfDocuments = (_b = model.numberOfDocuments) !== null && _b !== void 0 ? _b : 0;
        this.documents =
            (_d = (_c = model.documents) === null || _c === void 0 ? void 0 : _c.map((doc) => new ForgeProjectDocumentPreview(doc))) !== null && _d !== void 0 ? _d : [];
        this.features =
            (_f = (_e = model.features) === null || _e === void 0 ? void 0 : _e.map((feature) => new ForgeProjectFeaturePreview(feature))) !== null && _f !== void 0 ? _f : [];
        this.context = model.context
            ? new ForgeProjectContext(model.context)
            : undefined;
        this.fpContextId = model.fpContextId;
        this.meta = model.meta;
        this.tokenThemeSetId = model.tokenThemeSetId;
    }
    toRemote() {
        var _a;
        return Object.assign(Object.assign({}, this), { context: (_a = this.context) === null || _a === void 0 ? void 0 : _a.toRemote(), documents: this.documents.map((doc) => doc.toRemote()), features: this.features.map((feature) => feature.toRemote()), createdAt: this.createdAt.toISOString(), updatedAt: this.updatedAt.toISOString() });
    }
}
